import React, { PureComponent } from 'react';
import { connect } from 'shalala';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { Http } from '../../../../support';
import { useStore } from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class ReporteFacturacionClienteDownload extends PureComponent {
  state = {
    busy: false,
  };

  handleOnDownloadActionClick = async (detailed) => {
    const { filters } = this.props.facturacion;

    this.setState({
      busy: true,
    });

    const params = {
      date: filters.date,
      download: 1,
      detailed: detailed,
    };

    try {
      const headers = {};

      const response = await Http.get(`${window.BONJOUR_URL}/app/admin/reportes/facturacion`, {
        params,
        responseType: 'blob',
        headers,
      });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo',
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  render() {
    const { busy } = this.state;

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={true}
      >
        <LoadingButton
          variant="secondary"
          loading={busy}
          onClick={this.handleOnDownloadActionClick.bind(this, undefined)}
        >
          {busy === true ? 'Descargando' : 'Descargar'}
        </LoadingButton>

        <Dropdown.Toggle
          split
          variant="secondary"
          id="dropdown-split-basic"
        />

        <Dropdown.Menu>
          <Dropdown.Item
            as="div"
            onClick={this.handleOnDownloadActionClick.bind(this, 1)}
          >
            Descargar detallado
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapState = (store) => {
  return {
    facturacion: store.admin.reportes.facturacion.hits_clientes,
  };
};

const mapActions = (actions) => {
  return actions.admin.reportes.facturacion.hits_clientes;
};

export default connect(useStore, mapState, mapActions)(ReporteFacturacionClienteDownload);
